import {RequestStatus} from "../../common/Constants";

export const RequestStatusFilter = [
    {
        text: 'Unassigned',
        roles: [ "admin", "fbo" ,"farmer"],
        value: 'unassigned' ,
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Unassigned
            });

        }
    },
    {
        text: 'Unassigned (Paid)',
        roles: [ "admin", "fbo" ,"farmer"],
        value: 'unassigned_paid',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Unassigned
            });

            params.query.pay_status = "paid";
        }
    },
    {
        text: 'Unassigned (Payment Fail)',
        roles: [ "admin", "fbo" ,"farmer"],
        value: 'unassigned_payment_fail',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Unassigned
            });

            params.query.pay_status = "failed_payment";
        }
    },
    {
        text: 'Assigned',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'assigned',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Assigned
            });

        }
    },
    {
        text: 'Assigned (Not Started)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'assigned_not_started',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Assigned
            });

            params.query.request_start_status = "not_started";
        }
    },
    {
        text: 'Assigned (Started)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'assigned_started',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Assigned
            });

            params.query.request_start_status = "started";
        }
    },
    {
        text: 'Assigned (Pending Payment)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'assigned_pending_payment' ,
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Assigned
            });

            params.query.pay_status = "paid_partial";
        }
    },
    {
        text: 'Assigned (Pending Refund)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'assigned_pending_refund',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Assigned
            });

            params.query.pay_status = "failed_refund";
        }
    },
    {
        text: 'Assigned (Pending Confirmation)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'assigned_pending_confirmation',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Assigned
            });

            params.query.request_completion_status = "farmer_not_completed";
        }
    },
    {
        text: 'Completed' ,
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'completed',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Completed
            });

        }
    },
    {
        text: 'Completed (Not Rated)' ,
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'completed_not_rated',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Completed
            });

            params.query.request_rating_status = "not_rated";
        }
    },
    {
        text: 'Completed (Rated)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'completed_rated',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Completed
            });

            params.query.request_rating_status = "rated";
        }
    },
    {
        text: 'Cancelled' ,
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'cancelled',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Cancelled
            });

        }
    },
    {
        text: 'Cancelled (Not Refunded)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'cancelled_paid',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Cancelled
            });

            params.query.pay_status = "paid";
        }
    },
    {
        text: 'Cancelled (Full Refund)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'cancelled_refunded',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Cancelled
            });

            params.query.pay_status = "refunded";
        }
    },
    {
        text: 'Cancelled (Refund Fail)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'cancelled_refund_fail',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Cancelled
            });

            params.query.pay_status = "failed_refund";
        }
    },
    {
        text: 'Cancelled (Partial Refund)',
        roles: [ "admin", "owner" , "fbo" ,"farmer"],
        value: 'cancelled_refund_partial',
        onApply: (params) => {

            params.filter.push({
                key: "status",
                operator: "=",
                value: RequestStatus.Cancelled
            });

            params.query.pay_status = "refund_partial";
        }
    },
];

export const getStatusFiltersForRole = (role) => {
    return  RequestStatusFilter.filter(x => x.roles.includes(role));
};


// WEBPACK FOOTER //
// ./src/views/Request/RequestStatusConfiguration.js